import { BalloonOutlineIcon } from '@carboncopyco/icons';
import type {
  GuidanceTooltipSchemaType,
  Modification,
} from '@carboncopyco/types';
import { ColorHex } from '@carboncopyco/ui';
import classNames from 'classnames';
import { RuleIcon } from '../RuleIcon';
import { RulePreview } from '../RulePreview';
import { TextTitleWithTooltip } from '../RulePreview/RulePreview';

export type GuidanceTooltipsRulePreviewProps = {
  rule: Modification<GuidanceTooltipSchemaType.guidanceTooltip>;
  isDisabled?: boolean;
};

export const GuidanceTooltipsRulePreview = ({
  rule,
  isDisabled = false,
}: GuidanceTooltipsRulePreviewProps) => {
  return (
    <RulePreview>
      <div
        className={classNames('shrink-0', {
          'bg-ds-accent-100': isDisabled,
        })}
      >
        <RuleIcon>
          <BalloonOutlineIcon
            color={isDisabled ? ColorHex.natural200 : undefined}
          />
        </RuleIcon>
      </div>
      <TextTitleWithTooltip
        label={rule.content.title}
        isDisabled={isDisabled}
      />
    </RulePreview>
  );
};
